import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import { connect } from 'react-redux';

import ReactMapboxGl, { Marker, Cluster, Popup, ZoomControl } from 'react-mapbox-gl';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';

import * as classes from './ExecutiveSummaryFaults.module.css';

const ReactMap = ReactMapboxGl({
    accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
});

let mapProps = {
    center:         [-98.5795, 39.8283],
    zoom:           [3],
    style:          'mapbox://styles/mapbox/light-v9',
    containerStyle: {
        height: '100%',
        width:  '100%'
    }
};

const styles = {
    clusterMarker: {
        alignItems:     'center',
        borderRadius:   '3rem',
        color:          'white',
        cursor:         'pointer',
        display:        'flex',
        height:         '3rem',
        justifyContent: 'center',
        width:          '3rem'
    }
};

const ExecutiveSummaryFaults = ({
    activeNavCompany,
    bobLoading,
    companies,
    sites,
    sitesMeta,
    zoomSite,
    ...props
}) => {
    // eslint-disable-next-line no-unused-vars
    const [map, setMap] = useState(() => { });
    const [selectedSite, setSelectedSite] = useState({});
    const [faults, setFaults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (activeNavCompany) {
            const company = companies.find(item => item.company.id === activeNavCompany.id);
            const latitude = company.company.address ? company.company.address.latitude : 0;
            const longitude = company.company.address ? company.company.address.longitude : 0;
            if (company) {
                mapProps = {
                    center:         [longitude, latitude],
                    zoom:           [3],
                    style:          'mapbox://styles/mapbox/light-v9',
                    containerStyle: {
                        height: '100%',
                        width:  '100%'
                    }
                };
            }
        }
    }, [activeNavCompany]);

    useEffect(() => {
        if (!isEmpty(zoomSite) && zoomSite !== null) {
            mapProps = {
                center:         [zoomSite.siteLongitude, zoomSite.siteLatitude],
                zoom:           [18],
                style:          'mapbox://styles/mapbox/light-v9',
                containerStyle: {
                    height: '100%',
                    width:  '100%'
                }
            };
        } else {
            mapProps = {
                center:         [-98.5795, 39.8283],
                zoom:           [3],
                style:          'mapbox://styles/mapbox/light-v9',
                containerStyle: {
                    height: '100%',
                    width:  '100%'
                }
            };
        }
    }, [zoomSite]);

    useEffect(() => {
        const init = () => {
            setIsLoading(true);
            const calculatedFaults = [];

            sites.forEach(site => {
                for (var i = 0; i < site.highFaultCount; i++) {
                    calculatedFaults.push({
                        siteId:        site.siteId,
                        siteName:      site.siteName,
                        clientName:    site.clientName,
                        siteLatitude:  site.siteLatitude,
                        siteLongitude: site.siteLongitude,
                        priority:      'high'
                    });
                }

                for (var j = 0; j < site.mediumFaultCount; j++) {
                    calculatedFaults.push({
                        siteId:        site.siteId,
                        siteName:      site.siteName,
                        clientName:    site.clientName,
                        siteLatitude:  site.siteLatitude,
                        siteLongitude: site.siteLongitude,
                        priority:      'medium'
                    });
                }

                for (var k = 0; k < site.lowFaultCount; k++) {
                    calculatedFaults.push({
                        siteId:        site.siteId,
                        siteName:      site.siteName,
                        clientName:    site.clientName,
                        siteLatitude:  site.siteLatitude,
                        siteLongitude: site.siteLongitude,
                        priority:      'low'
                    });
                }
            });

            setFaults(calculatedFaults);
            setIsLoading(false);
        };

        if (sites) init();
    }, [sites]);


    const handleStyleLoad = map => {
        setMap({ map });
    };

    const clusterMarker = (coordinates, pointCount, getLeaves) => {
        const key = coordinates[0] + coordinates[1];
        const leaves = getLeaves();
        let nodeSize = '';

        if (leaves.length > 1000) {
            nodeSize = `${classes.large3}`;
        } else if (leaves.length <= 1000 && leaves.length > 750) {
            nodeSize = `${classes.large2}`;
        } else if (leaves.length <= 750 && leaves.length > 500) {
            nodeSize = `${classes.large1}`;
        }
        let highestPriority = `${classes.low}`;

        leaves.forEach(leaf => {
            if (leaf.props['data-feature'].priority === 'medium') highestPriority = `${classes.medium}`;
            if (leaf.props['data-feature'].priority === 'high') {
                highestPriority = `${classes.high}`;
                return;
            }
        });

        return (
            <Marker
                coordinates={coordinates}
                style={styles.clusterMarker}
                onMouseEnter={() => onMarkerHover(leaves)}
                onMouseLeave={() => onMarkerLeave()}
                className={`${nodeSize} ${highestPriority}`}
                key={key}
            >
                {pointCount}
            </Marker>
        );
    };

    const onMarkerHover = leaves => {
        let showPopup = true;
        let faultBreakdown = {high: 0, medium: 0, low: 0};

        leaves.forEach((item, index) => {
            if (item.props['data-feature'].priority === 'high') {
                faultBreakdown.high = faultBreakdown.high + 1;
            } else if (item.props['data-feature'].priority === 'medium') {
                faultBreakdown.medium = faultBreakdown.medium + 1;
            } else if (item.props['data-feature'].priority === 'low') {
                faultBreakdown.low = faultBreakdown.low + 1;
            }

            if (item.props['data-feature'].siteId !== leaves[0].props['data-feature'].siteId) {
                showPopup = false;
            }
        });

        if (showPopup) {
            setSelectedSite({ ...leaves[0].props['data-feature'], faults: faultBreakdown });
        }
    };

    const onMarkerLeave = () => {
        setSelectedSite({});
    };

    const renderMarkers = () => {

        return (
            <Cluster
                maxZoom={20}
                ClusterMarkerFactory={clusterMarker}
                zoomOnClick={true}
            >
                {faults.map((fault, index) => (
                    <Marker
                        key={index}
                        coordinates={[fault.siteLongitude, fault.siteLatitude]}
                        data-feature={fault}
                    >
                        <div title={fault.name} />
                    </Marker>
                ))}
            </Cluster>
        );
    };

    return (
        <ExecutiveSummaryTile isLoading={isEmpty(sitesMeta) || bobLoading.includes('FetchSiteScore') || isLoading}>
            {isEmpty(sitesMeta) || bobLoading.includes('FetchSiteScore') || isLoading ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <ReactMap
                    {...mapProps}
                    onStyleLoad={handleStyleLoad}
                >
                    {renderMarkers()}
                    {
                        !isEmpty(selectedSite) ?
                            <Popup
                                coordinates={[selectedSite.siteLongitude, selectedSite.siteLatitude]}
                                offset={{
                                    'bottom-left': [12, -38], 'bottom': [0, -38], 'bottom-right': [-12, -38]
                                }}
                            >
                                <div>
                                    {`Client - ${selectedSite.clientName}`}
                                </div>
                                <div>
                                    {`Site - ${selectedSite.siteName}`}
                                </div>
                                <div>
                                    {`High - ${selectedSite.faults.high}, Medium - ${selectedSite.faults.medium}, Low - ${selectedSite.faults.low}`}
                                </div>
                            </Popup>
                            :
                            null
                    }
                    <ZoomControl />
                </ReactMap>
            }
        </ExecutiveSummaryTile>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany: state.bob.activeNavCompany,
        bobLoading:       state.bob.bobLoading,
        companies:        state.core.companies,
        sites:            state.executiveSummary.sites,
        sitesMeta:        state.executiveSummary.sitesMeta
    };
};

export default connect(mapStateToProps, null)(ExecutiveSummaryFaults);
